@if (getTeams(); as teams) {
  <div class="game-summary">
    @for (team of teams; track team; let isFirst = $first) {
      <div class="game-summary__team">
        <div class="game-summary__team-main">
          <div class="game-summary__side">{{(isFirst ? 'SB_Home' : 'SB_Away') | translate}}</div>
          @if (team.kitStyleId) {
            <sb-kit
              [primaryColour]="team.kitPrimaryHexColour || '#ffffff'"
              [secondaryColour]="team.kitSecondaryHexColour || '#ffffff'"
              [kitStyleId]="team.kitStyleId"
            [size]="size"></sb-kit>
          } @else {
            <div
              [inlineSVG]="getTournamentImg()"
              [setSVGAttributes]="{ width: 'auto', height: 'auto' }"
            class="tournament-img"></div>
          }
          @if (team.name) {
            <div
              class="game-summary__team-name"
              [style.background]="colour.colourToHex(team.kitPrimaryHexColour)"
            [style.color]="colour.colourToHex(team.kitSecondaryHexColour)">{{team.name}}</div>
          }
        </div>
        @if (team.score) {
          <div class="game-summary__score">{{team.score}}</div>
        }
      </div>
      @if (isFirst) {
        <div class="game-summary__vs">
          @if (team.score !== undefined) {
            <div>-</div>
            <div class="game-summary__result">
              @if (result) {
                <sb-badge [message]="result.name" [badgeClass]="result.className" [isLarge]="true"></sb-badge>
              }
              @if (resultNote) {
                <div
                  class="game-summary__result-note"
                  [ngClass]="{ 'game-summary__result-note--lg': noScores() }"
                >{{resultNote}}</div>
              }
            </div>
          }
          @if (!team.score === undefined) {
            <div>VS</div>
            <sb-icon [name]="'sportIcon' + squad.sport.id" [hasColor]="true"></sb-icon>
          }
        </div>
      }
    }
  </div>
}
